module.exports = __webpack_public_path__ + "media/images/top/pap/icon/black/ico_angle_right-b67e0159204c859e374241a6f2155dd3.svg";